import { useContext } from 'react';
import { MdBadge, MdLocalHospital, MdLockOutline, MdPersonOutline } from 'react-icons/md';
import { AppContext } from '../App';
import logoWorded from '../assets/logo_worded.png';

export default function NfcDemo() {
  const appContext = useContext(AppContext);
  const notLinked = () => appContext.tellInfo('Not linked to hospital yet');

  return (
    <main className="HospiumNfcPage">
      <div className="HospiumNfcBackdrop" />
      <section className="HospiumNfcCard">
        <div className="HospiumNfcHeader"><img src={logoWorded} alt="Hospium" /><span><MdLockOutline /> NFC patient identity</span></div>
        <div className="HospiumNfcAvatar"><MdPersonOutline /></div>
        <span className="HospiumNfcStatus">Demo patient profile</span>
        <h1>PETER SHIHUMBI NDOMANO</h1>
        <div className="HospiumNfcDetails">
          <div><MdBadge /><span><small>Identity system</small>Hospium ID</span></div>
          <div><MdLocalHospital /><span><small>Hospital connection</small>Not linked yet</span></div>
        </div>
        <p className="HospiumNfcPrivacy">Only basic identity details are shown on this public NFC page. Clinical information requires authorized access through a connected hospital.</p>
        <div className="HospiumNfcActions">
          <button className="btn btn-primary btn-padded btn-rounded" onClick={notLinked}>Login to Self Care</button>
          <button className="btn btn-outline-primary btn-padded btn-rounded" onClick={notLinked}>Access patient in Hospium Core HIMS</button>
        </div>
      </section>
    </main>
  );
}
